import React, { Component } from 'react'


export default class VlecImg extends Component {
    constructor(props){
          super(props);
          this.state={};
          
    }
    componentWillMount(){
        //console.log(window.location.hostname);
      
    }
  render() {
    let imghost="";
    if(this.props.src&&this.props.src.indexOf('/')===0){}else{
        imghost="/";
    }
    if(window.location.hostname==="localhost"){
        if(this.props.type==="api")
        imghost="https://www.lenovofuturecenter.com/sit2";
        else
        imghost="https://www.lenovofuturecenter.com/sit2";
    }
    return (
        <img {...this.props} alt="" src={!!this.props.src?imghost+this.props.src:'images/1.jpg'}/>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/VlecImg/index.jsx